/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { List, ListContent, ListIcon, ListItem } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const uppercaseRegex = /[A-Z]/
const lowercaseRegex = /[a-z]/
const numberRegex = /\d/
const specialCharacterRegex = /[#?!@$%^&*-]/

const PasswordInteractiveHint = ({password}) => {
    const hasUppercase = uppercaseRegex.test(password)
    const hasLowercase = lowercaseRegex.test(password)
    const hasNumber = numberRegex.test(password)
    const hasSpecialCharacter = specialCharacterRegex.test(password)
    const hasMinimumLength = password.length >= 8
    const [t] = useTranslation()

    const rules = [
        {test: hasUppercase, message: t('reset_password.password_hint.at_least_one_uppercase')},
        {test: hasLowercase, message: t('reset_password.password_hint.at_least_one_lowercase')},
        {test: hasNumber, message: t('reset_password.password_hint.at_least_one_number')},
        {test: hasSpecialCharacter, message: t('reset_password.password_hint.at_least_one_special_char')},
        {test: hasMinimumLength, message: t('reset_password.password_hint.at_least_eight_characters')},
    ]

    return (
      <List>
          {rules.map(rule => (
            <ListItem
              key={rule.message}
              css={css`
                  color: ${rule.test ? 'green' : 'grey'};
                  font-size: .9em;
              `}>
                <ListIcon name={rule.test ? 'check' : 'remove'}/>
                <ListContent>{rule.message}</ListContent>
            </ListItem>
          ))}
      </List>
    )
}

export { PasswordInteractiveHint }
